/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 * 
 **/
import { createIcon } from "@v2/helpers/icons/create-icon";
export const NullMinusIcon = createIcon({
  displayName: "NullMinusIcon",
  viewBox: "0 0 16 16",
  path: (<g fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M14 8.75H2V7.25H14V8.75Z" fill="currentColor" /></g>)
});